import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { compose } from 'redux';

import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import parseAPIResponse from 'common/util/parseAPIResponse';
import withContexts from 'common/util/withContexts';

import AdminCreateJiraIssueModal from './AdminCreateJiraIssueModal';
import AdminJiraIssueForm from './AdminJiraIssueForm';
import AdminJiraIssues from './AdminJiraIssues';
import AdminSidebarSection from './AdminSidebarSection';
import { reloadPost } from '../../actions/posts';
import connect from '../../core/connect';
import Tappable from '../../Tappable';

import 'css/components/subdomain/admin/_AdminJiraPostSidebarSection.scss';

class AdminJiraPostSidebarSection extends Component {
  static propTypes = {
    company: PropTypes.shape({
      jira: PropTypes.shape({
        connected: PropTypes.bool,
      }),
    }),
    post: PropTypes.object,
  };

  state = {
    creatingIssue: false,
    error: null,
    formOpen: false,
    showCreateModal: false,
  };

  onCreateIssue = () => {
    this.setState({ showCreateModal: true });
  };

  onCloseCreateModal = () => {
    this.setState({ showCreateModal: false });
  };

  onCreateJiraIssue = async (issueData) => {
    this.setState({ error: null, creatingIssue: true });

    const { post } = this.props;
    const response = await AJAX.post('/api/jira/createAndLinkIssue', {
      customValues: issueData.customValues,
      jiraProjectID: issueData.projectID,
      jiraIssueTypeID: issueData.issueTypeID,
      issueDescription: issueData.description,
      issueSummary: issueData.summary,
      postID: post._id,
    });

    const { error, parsedResponse } = parseAPIResponse(response, {
      isSuccessful: (parsedResponse) => parsedResponse?.issue,
    });

    if (error) {
      this.setState({ error: error.message, creatingIssue: false });
      return;
    }

    // open new issue in a new tab
    // if popups are blocked by the browser, `issueWindow` will be `null`
    const { issue } = parsedResponse;
    const issueWindow = window.open(issue.url, '_blank', 'noopener');
    issueWindow?.focus();

    const { reloadPost } = this.props;
    reloadPost(post);
    this.setState({ creatingIssue: false, showCreateModal: false });
  };

  onToggleTypeahead = () => {
    const { formOpen } = this.state;
    this.setState({
      formOpen: !formOpen,
    });
  };

  renderAction() {
    return (
      <Tappable onTap={this.onToggleTypeahead}>
        <div>Link issue</div>
      </Tappable>
    );
  }

  renderCreateButton() {
    return (
      <Tappable onTap={this.onCreateIssue}>
        <div className="createButton">Create new issue</div>
      </Tappable>
    );
  }

  renderIssueForm() {
    const { formOpen } = this.state;
    if (!formOpen) {
      return null;
    }

    const { post } = this.props;
    return <AdminJiraIssueForm post={post} />;
  }

  render() {
    const {
      company: { jira },
    } = this.props;
    if (!jira || !jira.connected) {
      return null;
    }

    const { post } = this.props;
    const { creatingIssue, error, showCreateModal } = this.state;

    return (
      <>
        <AdminSidebarSection
          action={this.renderAction()}
          className="adminJiraPostSidebarSection"
          title="Jira Issues">
          {this.renderIssueForm()}
          <AdminJiraIssues post={post} />
          {this.renderCreateButton()}
        </AdminSidebarSection>
        {showCreateModal && (
          <AdminCreateJiraIssueModal
            creating={creatingIssue}
            error={error}
            title={post.title}
            description={post.details}
            onClose={this.onCloseCreateModal}
            onCreate={this.onCreateJiraIssue}
          />
        )}
      </>
    );
  }
}

export default compose(
  connect(null, { reloadPost }),
  withContexts(
    {
      company: CompanyContext,
    },
    {
      forwardRef: true,
    }
  )
)(AdminJiraPostSidebarSection);
